import { ErrorSnackbarContent } from 'ComponentLibrary'
import { ForbiddenError, MissingTokenError, UnauthorizedError, ValuationApiError } from '@einwert/valuation-api-client'
import { i18n } from 'ClientPortal/src/i18n/init'

/**
 * Shared error handler for converting errors to toast content
 * Used by both production and test code to ensure consistency
 */
export const handleError = (error: unknown): ErrorSnackbarContent | null => {
    if (error instanceof ForbiddenError) {
        return {
            headline: i18n.t('errors:forbidden.headline'),
            detail: i18n.t('errors:forbidden.detail'),
        }
    }

    if (error instanceof UnauthorizedError) {
        return {
            headline: i18n.t('errors:unauthorized.headline'),
            detail: i18n.t('errors:unauthorized.detail'),
        }
    }

    if (error instanceof MissingTokenError) {
        return {
            headline: i18n.t('errors:missingToken.headline'),
            detail: i18n.t('errors:missingToken.detail'),
        }
    }

    if (
        error instanceof ValuationApiError &&
        error.statusCode === 409 &&
        error.responseErrorName === 'ExternalParticipantEmailBelongsToManagedUser'
    ) {
        return {
            headline: i18n.t('errors:externalParticipantEmailBelongsToManagedUser.headline'),
            detail: i18n.t('errors:externalParticipantEmailBelongsToManagedUser.detail'),
        }
    }

    if (error instanceof ValuationApiError) {
        return {
            headline: `HTTP ${error.statusCode} ${error.response.statusText}`,
            detail: error.message,
        }
    }
    if (error && typeof error === 'object' && 'stack' in error && 'message' in error) {
        // Frontend Error
        return {
            headline: i18n.t('errors:frontend.headline'),
            detail: (error as Error).message,
        }
    }
    // Unknown error
    return {
        headline: i18n.t('errors:unexpected.headline'),
    }
}
